import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import "./baby-teething.css";
import Right from "../../right/Right";
import { fetchInitialData4 } from "../../fetchData";
import * as actions from "../Actions";
// import Eruption from './Eruption';
// import Shedding from './Shedding';
// import ChildTeethInfo from './ChildTeethInfo';
// import Articles from './Articles';
// import AddToothDetails from './AddToothDetails';
import * as teethactions from "./TeethingActions";
import Cookies from "js-cookie";

import Service from "../../service/Service";
import withContext from "../../../withContext";
const service = new Service();

class BabyTeething extends Component {
  constructor(props) {
    super(props);
    let initialData = {};
    var ArticlesData = [];
    var ChildTeethData = [];
    var TeethEruptionData = [];
    this.currentY = 0;
    this.currentM = 0;
    var currentMonth = 0;
    if (
      __isBrowser__ &&
      window.__initialData__ &&
      window.__initialData__["initialData"]
    ) {
      initialData = window.__initialData__["initialData"];
      if (initialData["data4"]) {
        ArticlesData = initialData["data4"]["result"]["ArticleInfo"];
        ChildTeethData = initialData["data3"]["result"];
        currentMonth = initialData["data3"]["currentMonth"];
      }
      if (initialData["data1"] && initialData["data1"]["result"]) {
        TeethEruptionData = initialData["data1"]["result"];
      }

      delete window.__initialData__;
    } else {
      if (
        props.staticContext &&
        props.staticContext.initialData &&
        props.staticContext.initialData["initialData"]
      ) {
        initialData = props.staticContext.initialData["initialData"];
        if (initialData["data4"]) {
          ArticlesData = initialData["data4"]["result"]["ArticleInfo"];
          ChildTeethData = initialData["data3"]["result"];
          currentMonth = initialData["data3"]["currentMonth"];
        }
        if (initialData["data1"] && initialData["data1"]["result"]) {
          TeethEruptionData = initialData["data1"]["result"];
        }
      }
    }
    this.state = {
      initialData: initialData,
      activeRef: "active-tab",
      activeTotRef: "",
      activeArti: "",
      activeErp: "active-ref-tab",
      tabarrow: "erparrow",
      activeShed: "",
      toothNo: 0,
      currentMonth: currentMonth,
      image: "",
      clickwedWeek: "",
      scrollwidth: "",
      halfwidth: "",
      weekwd: "",
      weeks: "",
      showmsg: false,
      isshowRef: "",
      isshowArt: "",
      isshowChildTeeth: "",
      isshowErpt: true,
      isshowShed: false,
      allteeth: "",
      monthSlider: "",
      isshowDropdown: "",
      teethCount: "",
      isshowDetails: false,
      insertThisTooth: "",
      TeethEruptionData: TeethEruptionData,
      TeethSheddingData: [],
      ChildTeethData: ChildTeethData,
      ArticlesData: ArticlesData,
      selectedChlDOB: 0,
      isToggleOn: false,
      userDate: "",
      toothSide: "",
      selectedJaw: "",
      currenttoothId: "",
      selectedChlId: "",
      selectedChlname: "",
      showChildrenList: false,
    };
  }

  static initialAction(reqUrl, ftk, authData, uId, childData) {
    var header = {
      "Content-Type": "application/json",
      ftk: global.ftk,
      uid: global.uID,
      "access-token": global.accessToken,
      "user-agent": global.userAgent,
      isdesktop: global.isdesktop,
    };
    let size = 10;
    if (reqUrl.includes("/page/")) {
      size = parseInt(reqUrl.split("/").pop()) * 10;
    }
    let body = JSON.stringify({});
    let obj1 = {
      url: global.api_url + "teeth/getreferenceteetheruptiondetail",
      body: JSON.stringify({
        pagesize: 10,
        pageno: 1,
        isIntent: true,
        isDesk: true,
      }),
    };

    let obj2 = {
      url: global.api_url + "teeth/getreferenceteethshedingdetail",
      body: JSON.stringify({
        pagesize: 10,
        pageno: 1,
        isIntent: true,
        isDesk: true,
      }),
    };
    let obj3 = {
      url: global.api_url + "teeth/getchildteetheruptiondetail",
      body: JSON.stringify({
        pagesize: 10,
        pageno: 1,
        isIntent: true,
        isDesk: true,
      }),
    };
    let obj4 = {
      url: global.api_url + "teeth/getteetharticle",
      body: JSON.stringify({
        pagesize: 10,
        pageno: 1,
        isIntent: true,
        isDesk: true,
      }),
    };
    return fetchInitialData4(obj1, obj2, obj3, obj4, JSON.stringify(header));
  }

  componentDidMount() {
    var childarray = [];
    document.addEventListener("click", actions.domClick);
    if (navigator.onLine) {
      if (
        !this.state.initialData ||
        (this.state.initialData &&
          Object.keys(this.state.initialData).length < 1)
      ) {
        service.showLoader();
        if (global.userAry["childData"]["UserChildList"] != null) {
          childarray = global.userAry["childData"]["UserChildList"];
        }
        let selectedChlId = 0;

        if (childarray != null && global.ftk && childarray.length > 0) {
          if (
            childarray.length != null &&
            !childarray[0].IsExpected &&
            childarray.length >= 1
          ) {
            selectedChlId = childarray[0].ChildId;
          } else if (
            childarray.length != null &&
            childarray[0].IsExpected &&
            childarray.length >= 2
          ) {
            selectedChlId = childarray[1].ChildId;
          }
          this.setState(
            {
              selectedChlId: selectedChlId,
            },
            () => {
              this.getErptData(selectedChlId);
              this.getChildData(selectedChlId);
              this.getArticleData();
            }
          );
          this.loadStateData();
          localStorage.setItem(
            "BabyTeethingData",
            JSON.stringify(this.state.initialData)
          );
        } else {
          this.getErptData();
          this.getArticleData();

          setTimeout(() => {
            this.loadStateData();
          }, 3000);
          // localStorage.setItem('BabyTeethingData', JSON.stringify(this.state.initialData));
        }
      } else {
        localStorage.setItem(
          "BabyTeethingData",
          JSON.stringify(this.state.initialData)
        );
        if (localStorage.getItem("BabyTeethingData")) {
          this.setState({
            initialData: JSON.parse(localStorage.getItem("BabyTeethingData")),
          });
        }
        this.loadStateData();
      }
    } else {
      if (localStorage.getItem("BabyTeethingData")) {
        this.setState({
          initialData: JSON.parse(localStorage.getItem("BabyTeethingData")),
        });
        this.loadStateData();
      }
      service.hideLoader();
    }
    setTimeout(() => {
      this.loadSliders();
    }, 5000);
  }

  componentWillUnmount() {
    document.removeEventListener("click", actions.domClick);
  }
  loadSliders() {
    let slider = document.querySelectorAll(".article_slider");
    for (let i = 0; i < slider.length; i++) {
      let margin = 20;
      let extraWidth = 30;
      let cnt = slider[i].getAttribute("data-count");

      if (slider[i].getElementsByClassName("article_slide")[0]) {
        let sliderulwidth =
          cnt *
          slider[i].getElementsByClassName("article_slide")[0].offsetWidth;

        let marginbetweenimages = cnt * margin;
        slider[i].style.width =
          sliderulwidth + marginbetweenimages + extraWidth + "px";
      }
      if (
        slider[i].offsetWidth <
        document.getElementsByClassName("sub-container")[0].offsetWidth
      ) {
        if (slider[i].nextSibling) {
          slider[i].nextSibling.remove();
        }
      }
    }
  }
  loadStateData() {
    if (global.ftk !== "") {
      this.setState({ isLogin: true, showChildrenList: true });
    } else {
      this.setState({ isLogin: false, showChildrenList: false });
    }
    this.setState({
      activeRef: "active-tab",
      activeErp: "active-ref-tab",
      tabarrow: "erparrow",
      isshowRef: true,
      isshowArt: false,
      isshowChildTeeth: false,
      isshowErpt: true,
      isshowShed: false,
      isshowDropdown: false,
      isshowDetails: false,
      defaultArtImg: false,
      isreadmore: false,
    });

    this.loadteethingdata();
    setTimeout(() => {
      try {
        this.state.scrollwidth = document.querySelector(
          ".baby-teething-tool"
        ).offsetWidth;
        this.state.halfwidth = this.state.scrollwidth / 2;
        this.state.weekwd = document.querySelector(".week-bar li").offsetWidth;
        this.state.weeks = document.querySelectorAll(".week-bar li");
        let a;
        for (
          let j = 1;
          j <= document.querySelectorAll(".week-bar li").length;
          j++
        ) {
          let wd = j * this.state.weekwd;
          if (wd > this.state.halfwidth) {
            a = j - 1;
            this.setState({ centerMonth: j - 1 });
            break;
          }
        }
        for (
          let i = 0;
          i <= document.querySelectorAll(".week-bar li").length;
          i++
        ) {
          if (this.state.weeks[i].classList.contains("curr-week")) {
            document.querySelector(".weeks-section").scrollLeft =
              this.state.weekwd * (i - a);
            break;
          }
        }
      } catch (err) {
        return "";
      }
    }, 100);
  }

  getErptData(childId) {
    var postData = "";
    if (childId) {
      postData = {
        childId: childId,
      };
    } else {
      postData = {
        childId: "",
      };
    }
    var url = global.api_ci_url + "BabyTeething/getErptData";
    service
      .postServiceCall(url, postData)
      .then((json) => {
        if (json["result"]) {
          let initialData = this.state.initialData;
          initialData["data1"] = json;
          this.setState({
            initialData: initialData,
          });
          this.currentM = json["currentMonth"];
        }
        service.hideLoader();
      })
      .catch((error) => {
        console.error(error);
        service.hideLoader();
      });
  }

  getChildData(childId) {
    var postData = {
      childId: childId,
    };
    var url = global.api_ci_url + "BabyTeething/getChildData";
    service
      .postServiceCall(url, postData)
      .then((json) => {
        if (json["result"]) {
          let initialData = this.state.initialData;
          initialData["data3"] = json;
          this.setState({
            initialData: initialData,
            ChildTeethData: json["result"],
          });

          var chlDOB = document.querySelector("#selectedChildDOB").value;
          this.currentY = teethactions.getCurrentYear(chlDOB);
          this.currentM = json["currentMonth"];
          let teeth_Count = 0;
          for (let i = 0; i < json["result"].length; i++) {
            if (json["result"][i].isHighLited != 0) {
              teeth_Count += 1;
            }
          }
          this.setState({ teethCount: teeth_Count });
          setTimeout(() => {
            teethactions.changeData(this, this.currentM, this.currentY);
          }, 500);
        }
        service.hideLoader();
      })
      .catch((error) => {
        console.error(error);
        service.hideLoader();
      });
  }

  getArticleData() {
    var postData = {};
    var url = global.api_ci_url + "BabyTeething/getArticleData";
    service
      .postServiceCall(url, postData)
      .then((json) => {
        if (json["result"]) {
          let initialData = this.state.initialData;
          initialData["data4"] = json;
          this.setState({
            initialData: initialData,
            ArticlesData: json["result"]["ArticleInfo"],
          });
        }
        service.hideLoader();
      })
      .catch((error) => {
        console.error(error);
        service.hideLoader();
      });
  }
  getOnlydate(date) {
    var day = date.getDate();
    var monthIndex = date.getMonth() + 1;
    var year = date.getFullYear();
    var h = date.getUTCHours();
    var m = date.getUTCMinutes();
    var s = date.getUTCSeconds();
    var ms = date.getMilliseconds();
    return day + "-" + monthIndex + "-" + year;
  }
  showRefContent(tab) {
    if (tab == "erp") {
      this.setState({
        activeErp: "active-ref-tab",
        activeShed: "",
        tabarrow: "erparrow",
        isshowErpt: true,
        isshowShed: false,
        TeethEruptionData: this.state.initialData.data1.result,
      });
    } else {
      this.setState({
        activeErp: "",
        activeShed: "active-ref-tab",
        tabarrow: "shedarrow",
        isshowErpt: false,
        isshowShed: true,
        TeethSheddingData: this.state.initialData.data2.result,
      });
    }
    setTimeout(() => {
      teethactions.changeData(this, this.currentM, this.currentY);
    }, 100);
  }
  showtoastmsg() {
    this.setState({ showmsg: true });
    setTimeout(() => {
      this.setState({ showmsg: false });
    }, 3000);
  }

  loadteethingdata() {
    var childarray = [];
    if (global.ftk) {
      childarray = global.userAry["childData"]["UserChildList"];
      this.setState({
        currentMonth: this.state.currentMonth,
      });
      this.currentM = this.state.currentMonth;
      var chlDOB;
      if (childarray && childarray.length >= 1) {
        if (childarray[0].IsExpected && childarray.length == 1) {
          this.setState({
            currentMonth: 0,
            currentYear: 0,
          });
          this.currentY = 0;
          this.currentM = 0;
          setTimeout(() => {
            this.weekInfo(1, "month_" + 1);
          }, 50);
        } else if (!childarray[0].IsExpected && childarray.length >= 1) {
          this.setState({
            selectedChlId: childarray[0].ChildId,
            selectedChlDOB: childarray[0].DOB,
            selectedChlname: childarray[0].ChildName,
          });
          chlDOB = childarray[0].DOB;
          this.getErptData(childarray[0].ChildId);
          this.getChildData(childarray[0].ChildId);
          this.setState({
            currentMonth: this.currentM,
          });
        } else if (childarray[0].IsExpected && childarray.length >= 2) {
          this.setState({
            selectedChlId: childarray[1].ChildId,
            selectedChlDOB: childarray[1].DOB,
            selectedChlname: childarray[1].ChildName,
          });
          chlDOB = childarray[0].DOB;
          this.getErptData(childarray[1].ChildId);
          this.getChildData(childarray[1].ChildId);
          this.setState({
            currentMonth: this.currentM,
          });
        }
      } else if (childarray == null || childarray.length == 0) {
        this.setState({
          currentMonth: 0,
          currentYear: 0,
        });
        this.currentY = 0;
        this.currentM = 0;
        setTimeout(() => {
          this.weekInfo(1, "month_" + 1);
        }, 50);
        // console.log("this is zero child-->",this.state.initialData.data1.result);
        var toothdata = this.state.initialData.data1.result;
        this.setState({
          TeethEruptionData: toothdata,
          showChildrenList: false,
        });
      }
    } else {
      console.log("not logged in");
      this.setState({
        currentMonth: 0,
        currentYear: 0,
        showChildrenList: false,
      });
      this.currentY = 0;
      this.currentM = 0;
      setTimeout(() => {
        this.weekInfo(1, "month_" + 1);
      }, 50);

      if (this.state.initialData && this.state.initialData.data1.result) {
        var toothdata = this.state.initialData.data1.result;
        this.setState({
          TeethEruptionData: toothdata,
        });
      }
    }
  }

  weekInfo(tet, monthNo) {
    this.setState({ clickwedWeek: monthNo });
    let ul;
    if (document.querySelector(".monthbar")) {
      ul = document.querySelector(".monthbar");
    }

    let alllist = ul.getElementsByTagName("li");
    let thismonth;
    let currentindex;
    for (let j = 0; j < alllist.length; j++) {
      if (monthNo == alllist[j].id) {
        thismonth = alllist[j];
        currentindex = j;
        break;
      }
    }
    if (
      !thismonth.firstChild.children[0].classList.contains("weekcircle") &&
      !thismonth.classList.contains("sel-week")
    ) {
      thismonth.classList.add("sel-week");
      thismonth.firstChild.children[0].classList.add("greycircle");
      thismonth.firstChild.children[1].classList.add("wk-txt");
      if (thismonth.id.includes("year_")) {
        thismonth.firstChild.children[1].innerHTML = "Years";
      } else {
        thismonth.firstChild.children[1].innerHTML = "Months";
      }
    } else if (
      !thismonth.classList.contains("curr-week") &&
      thismonth.firstChild.children[0].classList.contains("weekcircle")
    ) {
      thismonth.classList.add("curr-week");
      thismonth.firstChild.children[1].classList.add("currentweek");
      if (thismonth.id.includes("year_")) {
        thismonth.firstChild.children[1].innerHTML = "Current<br/> Year";
      } else {
        thismonth.firstChild.children[1].innerHTML = "Current<br/> Month";
      }
    }
    for (let i = 0; i < alllist.length; i++) {
      if (thismonth != alllist[i]) {
        alllist[i].classList.remove("sel-week");
        alllist[i].classList.remove("curr-week");
        alllist[i].firstChild.children[0].classList.remove("greycircle");
        alllist[i].firstChild.children[1].classList.remove("wk-txt");
        alllist[i].firstChild.children[1].innerHTML = "";
      }
    }

    for (let i = 1; i <= alllist.length; i++) {
      let wd = i * this.state.weekwd;
      if (wd > this.state.halfwidth) {
        if (currentindex >= i - 1) {
          let scrolllft = (currentindex - (i - 1)) * this.state.weekwd;
          document.querySelector(".weeks-section").scrollLeft = scrolllft;
          break;
        } else {
          document.querySelector(".weeks-section").scrollLeft = 0;
          break;
        }
      }
    }

    this.setState({
      allteeth: document.getElementsByClassName("baby-teeth"),
    });
    this.chlErptnInfo(monthNo);
  }
  displayMonthslider() {
    let monthslider = [];

    for (let i = 1; i <= 36; i++) {
      if (this.state.currentMonth == i) {
        monthslider.push(
          <li
            key={i}
            className="curr-week GTM-month"
            id={"month_" + i}
            data-monthss={this.state.toothMonth}
            onClick={(e) => this.weekInfo(1, "month_" + i)}>
            <div className="allweeks GTM-month">
              <span className="week weekcircle GTM-month">
                <span className="GTM-month">{i < 10 ? "0" + i : i}</span>
              </span>
              <span className="currentweek GTM-month">
                Current
                <br /> Month
              </span>
            </div>
          </li>
        );
      } else {
        monthslider.push(
          <li
            className="GTM-month"
            key={i}
            id={"month_" + i}
            onClick={(e) => this.weekInfo(1, "month_" + i)}>
            <div className="allweeks GTM-month">
              <span className="week GTM-month">
                <span className="GTM-month">{i < 10 ? "0" + i : i}</span>
              </span>
              <span className="GTM-month"></span>
            </div>
          </li>
        );
      }
    }
    for (let j = 4; j <= 12; j++) {
      if (this.state.currentYear == j) {
        monthslider.push(
          <li
            key={j + 33}
            className="curr-week GTM-month"
            id={"year_" + j}
            onClick={(e) => this.weekInfo(1, "year_" + j)}>
            <div className="allweeks GTM-month">
              <span className="week weekcircle GTM-month">
                <span className="GTM-month">{j < 10 ? "0" + j : j}</span>
              </span>
              <span className="currentweek GTM-month">
                Current
                <br /> Year
              </span>
            </div>
          </li>
        );
      } else {
        monthslider.push(
          <li
            className="GTM-month"
            key={j + 33}
            id={"year_" + j}
            onClick={(e) => this.weekInfo(1, "year_" + j)}>
            <div className="allweeks GTM-month">
              <span className="week GTM-month">
                <span className="GTM-month">{j < 10 ? "0" + j : j}</span>
              </span>
              <span className="GTM-month"></span>
            </div>
          </li>
        );
      }
    }

    return monthslider;
  }

  slideLeft = (id) => {
    var a = "";
    var b = "";
    var yearOrMonth = "";
    a = id.split("_");
    if (id.includes("month_")) {
      b = parseInt(a[1]) - 1;
      yearOrMonth = "month_";
    }
    if (id.includes("year_")) {
      if (id == "year_4") {
        b = 36;
        yearOrMonth = "month_";
      } else {
        b = parseInt(a[1]) - 1;
        yearOrMonth = "year_";
      }
    }
    if (parseInt(a[1]) > 1) {
      this.weekInfo(1, yearOrMonth + b);
    }
  };

  slideRight = (id) => {
    var a = "";
    var b = "";
    var yearOrMonth = "";
    a = id.split("_");
    if (id.includes("month_")) {
      b = parseInt(a[1]) + 1;
      yearOrMonth = "month_";
    }
    if (id.includes("year_")) {
      if (id == "year_12") {
        yearOrMonth = "month_";
        b = 1;
      } else {
        b = parseInt(a[1]) + 1;
        yearOrMonth = "year_";
      }
    }
    if (parseInt(a[1]) < 36) {
      this.weekInfo(1, yearOrMonth + b);
    } else {
      this.weekInfo(1, "year_" + 4);
    }
  };

  showDet(mon, e) {
    var curr_mon_id = "";
    if (document.querySelector(".curr-week")) {
      curr_mon_id = document.querySelector(".curr-week").id;
    } else if (document.querySelector(".sel-week")) {
      curr_mon_id = document.querySelector(".sel-week").id;
    }
    let thisteeth = document.querySelector("#" + e);
    let highlighted, erpStartMonth, erpEndMonth;
    var datecount = 0,
      erruptDate,
      shedDate,
      ishighlight = 0;
    let teethinfo = "";
    var startMonth = "";
    var endMonth = "";
    var ishighlight;
    var TeethEruptionData = [];
    if (global.ftk) {
      if (
        global.userAry["childData"]["UserChildList"] != null &&
        global.userAry["childData"]["UserChildList"].length != 0
      ) {
        TeethEruptionData = this.state.ChildTeethData;
      } else {
        TeethEruptionData = this.state.TeethEruptionData;
      }
    } else {
      TeethEruptionData = this.state.TeethEruptionData;
    }
    let eleID = e.split("_");
    let selectedToothId = parseInt(eleID[1]);
    let selectedJaw = "";
    let toothSide = "";
    var toothMonth = "";
    this.setState({
      userDate: "",
    });
    for (let i = 0; i < TeethEruptionData.length; i++) {
      if (TeethEruptionData[i].toothId == selectedToothId) {
        if (TeethEruptionData[i].isHighLited == 1) {
          document.getElementById(e).children[1].style.display = "block";
          ishighlight = 1;
        }
        if (selectedToothId >= 1 && selectedToothId <= 5) {
          selectedJaw = "lower";
          toothSide = "left";
        } else if (selectedToothId >= 6 && selectedToothId <= 10) {
          selectedJaw = "lower";
          toothSide = "right";
        } else if (selectedToothId >= 11 && selectedToothId <= 15) {
          selectedJaw = "upper";
          toothSide = "right";
        } else if (selectedToothId >= 15 && selectedToothId <= 20) {
          selectedJaw = "upper";
          toothSide = "lower";
        }
        if (this.state.isLogin) {
          if (
            global.userAry["childData"]["UserChildList"] != null &&
            global.userAry["childData"]["UserChildList"].length != 0
          ) {
            if (curr_mon_id.includes("month")) {
              startMonth = TeethEruptionData[i].startMonth;
              endMonth = TeethEruptionData[i].endMonth;
              toothMonth = startMonth + "-" + endMonth + " months";
            } else if (curr_mon_id.includes("year")) {
              startMonth = TeethEruptionData[i].startYear;
              endMonth = TeethEruptionData[i].endYear;
              toothMonth = startMonth + "-" + endMonth + " year";
            }
          } else {
            startMonth = TeethEruptionData[i].startMonth;
            endMonth = TeethEruptionData[i].endMonth;
            toothMonth = startMonth + "-" + endMonth + " months";
          }
        } else {
          if (curr_mon_id.includes("month")) {
            startMonth = TeethEruptionData[i].startMonth;
            endMonth = TeethEruptionData[i].endMonth;
            toothMonth = startMonth + "-" + endMonth + " months";
          } else if (curr_mon_id.includes("year")) {
            startMonth = TeethEruptionData[i].startYear;
            endMonth = TeethEruptionData[i].endYear;
            toothMonth = startMonth + "-" + endMonth + " year";
          }
        }

        erruptDate = TeethEruptionData[i].toothErruptionDate;
        shedDate = TeethEruptionData[i].toothSheddingDate;
        this.setState({
          toothName: TeethEruptionData[i].toothName,
          toothMonth: toothMonth,
          selectedJaw: selectedJaw,
          toothSide: toothSide,
          currenttoothId: selectedToothId,
        });
        highlighted = TeethEruptionData[i].highlightedTeeth;
        erpStartMonth = TeethEruptionData[i].startMonth;
        if (erruptDate && !shedDate) {
          teethinfo = this.getOnlydate(new Date(erruptDate));
          this.setState({ userDate: teethinfo });
          break;
        } else if (!erruptDate && shedDate) {
          teethinfo = this.getOnlydate(new Date(shedDate));
          this.setState({ userDate: teethinfo });
          break;
        } else if (shedDate > erruptDate) {
          teethinfo = this.getOnlydate(new Date(shedDate));
          this.setState({ userDate: teethinfo });
          break;
        } else {
          this.setState({
            userDate: "",
          });
          break;
        }

        // this.setState({
        //     toothName: TeethEruptionData[i].toothName,
        //     toothMonth: startMonth + '-' + endMonth + ' months',
        //     selectedJaw : selectedJaw,
        //     toothSide : toothSide,
        //     currenttoothId : selectedToothId
        // });
        // if(TeethEruptionData[i].toothErruptionDate && TeethEruptionData[i].toothErruptionDate !=""){
        //     let seleErruptonDate = new Date(TeethEruptionData[i].toothErruptionDate);
        //     this.setState({
        //         userDate:seleErruptonDate.getDate()+' '+ seleErruptonDate.toLocaleString('default', {month:'short'})+' '+seleErruptonDate.getFullYear()
        //     });
        // }
        // if(TeethEruptionData[i].toothSheddingDate && TeethEruptionData[i].toothSheddingDate !=""){
        //     let seleErruptonDate = new Date(TeethEruptionData[i].toothSheddingDate);
        //     this.setState({
        //         userDate:seleErruptonDate.getDate()+' '+ seleErruptonDate.toLocaleString('default', {month:'short'})+' '+seleErruptonDate.getFullYear()
        //     });

        // }
      }
    }

    document.querySelector(".tooth-info").style.display = "block";
    document.querySelector(".lower-jaw").style.display = "block";
    document.querySelector(".upper-jaw").style.display = "block";

    let allteeth = this.state.allteeth;
    var highlightedId = "";
    if (highlighted) {
      highlightedId = highlighted.split(",");
    }
    for (let i = 0; i < allteeth.length; i++) {
      allteeth[i].children[1].style.display = "none";
    }
    thisteeth.parentNode.children[1].style.display = "block";
  }

  erptnInfo(thismonth) {
    var erpsrtmth = document.getElementsByClassName("erpstartmonth");
    var erpendmth = document.getElementsByClassName("erpendmonth");
    var z, a, b, c, success;
    let allteeth = this.state.allteeth;
    for (let i = 0; i < erpsrtmth.length; i++) {
      a = thismonth;
      b = erpsrtmth[i].value;
      c = erpendmth[i].value;

      if (a == b) {
        z = erpsrtmth[i].parentElement.firstChild.getAttribute("id");
        success = 1;
        break;
      } else if (a <= 5) {
        for (let j = 0; j < allteeth.length; j++) {
          allteeth[j].children[2].style.display = "none";
          allteeth[j].children[1].style.display = "none";
          allteeth[j].children[0].style.display = "block";
          allteeth[j].children[3].style.display = "none";
        }
        document.querySelector(".erruption-sect .tooth-info").style.display =
          "none";
        document.querySelector(".erruption-sect .lower-jaw").style.display =
          "block";
        document.querySelector(".erruption-sect .upper-jaw").style.display =
          "block";
        z = 0;
        success = 1;
        break;
      } else if (a > 25 && a < 34) {
        z = "pink_20";
        success = 1;
      } else if (a > 33) {
        for (let j = 0; j < allteeth.length; j++) {
          allteeth[j].children[2].style.display = "none";
          allteeth[j].children[1].style.display = "block";
          allteeth[j].children[0].style.display = "none";
          allteeth[j].children[3].style.display = "none";
        }
        document.querySelector(".erruption-sect .tooth-info").style.display =
          "none";
        document.querySelector(".erruption-sect .lower-jaw").style.display =
          "block";
        document.querySelector(".erruption-sect .upper-jaw").style.display =
          "block";
        z = 0;
      }
    }
    if (success != 1) {
      for (let i = 0; i < erpsrtmth.length; i++) {
        a = parseInt(thismonth);
        b = parseInt(erpsrtmth[i].value);
        c = parseInt(erpendmth[i].value);
        if (b < a && a < c) {
          z = erpsrtmth[i].parentElement.firstChild.getAttribute("id");
          break;
        }
      }
    }
  }
  shedInfo(thisyear) {
    let shedsrtyr = document
      .querySelector(".shedding-sect")
      .getElementsByClassName("erpstartmonth");
    let shedendyr = document
      .querySelector(".shedding-sect")
      .getElementsByClassName("erpendmonth");
    var z, a, b, c, success;
    let allteeth = this.state.allteeth;
    for (let i = 0; i < shedsrtyr.length; i++) {
      a = thisyear;
      b = shedsrtyr[i].value;
      c = shedendyr[i].value;

      if (a == b) {
        z = shedsrtyr[i].parentElement.firstChild.getAttribute("id");
        success = 1;
        break;
      } else if (a == 12) {
        for (let j = 0; j < allteeth.length; j++) {
          allteeth[j].children[2].style.display = "none";
          allteeth[j].children[1].style.display = "none";
          allteeth[j].children[0].style.display = "block";
          allteeth[j].children[3].style.display = "none";
        }
        document.querySelector(".shedding-sect .tooth-info").style.display =
          "none";
        document.querySelector(".shedding-sect .lower-jaw").style.display =
          "block";
        document.querySelector(".shedding-sect .upper-jaw").style.display =
          "block";
        z = 0;
        success = 1;
        break;
      }
    }
    if (success != 1) {
      for (let i = 0; i < shedsrtyr.length; i++) {
        a = thisyear;
        b = shedsrtyr[i].value;
        c = shedendyr[i].value;
        if (b < a && a <= c) {
          z = shedsrtyr[i].parentElement.firstChild.getAttribute("id");
          break;
        }
      }
    }
  }
  chlErptnInfo(thismonth) {
    var splitindex = "";
    var currmonth = "";
    var chlsrtmn = "";
    var chlendmn = "";
    var shedsrtyr = "";
    var shedendyr = "";
    var z, a, b, c, success;
    let allteeth = this.state.allteeth;
    if (thismonth.includes("month_")) {
      splitindex = thismonth.split("_");
      currmonth = parseInt(splitindex[1]);
      chlsrtmn = document
        .querySelector(".tooth-erptn-inner")
        .getElementsByClassName("childstartmonth");
      chlendmn = document
        .querySelector(".tooth-erptn-inner")
        .getElementsByClassName("childendmonth");
      for (let i = 0; i < chlsrtmn.length; i++) {
        a = parseInt(currmonth);
        b = chlsrtmn[i].value;
        c = chlendmn[i].value;

        if (a == b) {
          z = chlsrtmn[i].parentElement.firstChild.getAttribute("id");
          success = 1;
          break;
        } else if (a <= 5) {
          for (let j = 0; j < allteeth.length; j++) {
            allteeth[j].children[1].style.display = "none";
          }
          document.querySelector(
            ".tooth-erptn-inner .tooth-info"
          ).style.display = "none";
          document.querySelector(
            ".tooth-erptn-inner .lower-jaw"
          ).style.display = "block";
          document.querySelector(
            ".tooth-erptn-inner .upper-jaw"
          ).style.display = "block";
          z = 0;
          success = 1;
          break;
        } else if (a > 25 && a < 34) {
          z = chlsrtmn[i].parentElement.firstChild.getAttribute("id");
          success = 1;
        } else if (a >= 34) {
          for (let j = 0; j < allteeth.length; j++) {
            allteeth[j].children[1].style.display = "none";
          }
          document.querySelector(
            ".tooth-erptn-inner .tooth-info"
          ).style.display = "none";
          document.querySelector(
            ".tooth-erptn-inner .lower-jaw"
          ).style.display = "block";
          document.querySelector(
            ".tooth-erptn-inner .upper-jaw"
          ).style.display = "block";
          success = 1;
          z = 0;
          break;
        }
      }
      if (success != 1) {
        for (let i = 0; i < chlsrtmn.length; i++) {
          a = parseInt(currmonth);
          b = parseInt(chlsrtmn[i].value);
          c = parseInt(chlendmn[i].value);
          if (b < a && a < c) {
            z = chlsrtmn[i].parentElement.firstChild.getAttribute("id");
            break;
          }
        }
      }
      if (z != 0 && z != undefined && z != "undefined") {
        this.showDet(0, z);
      }
    } else if (thismonth.includes("year_")) {
      splitindex = thismonth.split("_");
      currmonth = parseInt(splitindex[1]);
      shedsrtyr = document
        .querySelector(".tooth-erptn-inner")
        .getElementsByClassName("childshedstartYear");
      shedendyr = document
        .querySelector(".tooth-erptn-inner")
        .getElementsByClassName("childshedendYear");
      for (let i = 0; i < shedsrtyr.length; i++) {
        a = currmonth;
        b = shedsrtyr[i].value;
        c = shedendyr[i].value;

        if (a == b) {
          z = shedsrtyr[i].parentElement.firstChild.getAttribute("id");
          success = 1;
          break;
        } else if (a == 4 || a == 5 || a == 12) {
          for (let j = 0; j < allteeth.length; j++) {
            allteeth[j].children[2].style.display = "none";
            allteeth[j].children[1].style.display = "none";
            allteeth[j].children[0].style.display = "block";
            allteeth[j].children[3].style.display = "none";
          }
          document.querySelector(
            ".tooth-erptn-inner .tooth-info"
          ).style.display = "none";
          document.querySelector(
            ".tooth-erptn-inner .lower-jaw"
          ).style.display = "block";
          document.querySelector(
            ".tooth-erptn-inner .upper-jaw"
          ).style.display = "block";
          z = 0;
          success = 1;
          break;
        }
      }
      if (success != 1) {
        for (let i = 0; i < shedsrtyr.length; i++) {
          a = currmonth;
          b = shedsrtyr[i].value;
          c = shedendyr[i].value;
          if (b < a && a <= c) {
            z = shedsrtyr[i].parentElement.firstChild.getAttribute("id");
            break;
          }
        }
      }
      if (z != 0 && z != undefined && z != "undefined") {
        this.showDet(0, z);
      }
    }
  }
  childrenlist() {
    if (this.state.isshowDropdown === false) {
      this.setState({ isshowDropdown: true });
    } else {
      this.setState({ isshowDropdown: false });
    }
  }

  selectChild(childId, childName, childDOB) {
    this.setState({
      selectedChlId: childId,
      isshowDropdown: false,
      selectedChlname: childName,
      selectedChlDOB: childDOB,
    });
    this.getErptData(childId);
    this.getChildData(childId);
    Cookies.set("selectedchildID", childId);
    setTimeout(() => {
      if (this.state.isshowRef && this.state.isshowErpt) {
        this.setState({
          TeethEruptionData: this.state.initialData.data1.result,
        });
      } else if (this.state.isshowRef && this.state.isshowShed) {
        this.setState({
          TeethSheddingData: this.state.initialData.data2.result,
        });
      } else if (this.state.isshowChildTeeth) {
        this.setState({
          ChildTeethData: this.state.initialData.data3.result,
        });
      }
    }, 1000);
  }
  toggleList() {
    this.setState({ isToggleOn: !this.state.isToggleOn });
  }

  addToothDetails(thID, childId, edate) {
    Cookies.set("editdate", "");
    if (global.ftk) {
      if (global.userAry["childData"]["UserChildList"]) {
        if (global.userAry["childData"]["UserChildList"].length > 0) {
          if (
            global.userAry["childData"]["UserChildList"] == null ||
            (global.userAry["childData"]["UserChildList"][0].IsExpected &&
              global.userAry["childData"]["UserChildList"].length < 2)
          ) {
            service.showAlert("Please add child details");
            window.location.href =
              "/my-account/myprofile?URL=" + global.currentURL;
          } else {
            Cookies.set("selectedchildID", childId);
            Cookies.set("selToothId", thID);
            Cookies.set("editdate", edate);
            var url = `/tools/baby-teething/${this.state.selectedJaw}-${
              this.state.toothSide
            }-${service.genquestionurl(this.state.toothName)}-tooth-${
              this.state.currenttoothId
            }`;
            // let url = ('/tools/baby-teething/'+ this.state.selectedJaw +'-'+this.state.toothSide+'-'+this.state.toothName+'-tooth-'+this.state.currenttoothId).replace('/ /g','-');
            window.location.href = url;
          }
        } else {
          service.showAlert("Please add child details");
          window.location.href =
            "/my-account/myprofile?URL=" + global.currentURL;
        }
        service.gardianProfileChk();
      } else {
        service.showAlert("Please add child details");
        window.location.href = "/my-account/myprofile?URL=" + global.currentURL;
      }
    } else {
      service.showAlert("Please Login");
      window.location.href = global.loginUrl + "?URL=" + global.currentURL;
      return false;
    }
  }

  render() {
    var userchildarray = [];
    var ChildTeethData = [];
    var refereChartdata = [];
    if (global.ftk) {
      if (
        global.userAry["childData"]["UserChildList"] != null &&
        global.userAry["childData"]["UserChildList"].length > 0
      ) {
        userchildarray = global.userAry["childData"]["UserChildList"];
        if (userchildarray.length != 0 || userchildarray.length != null) {
          ChildTeethData = this.state.ChildTeethData;
          refereChartdata = this.state.ChildTeethData.sort(function (a, b) {
            return a.toothNumber - b.toothNumber;
          });
        } else {
          ChildTeethData = this.state.TeethEruptionData;
          refereChartdata = this.state.ChildTeethData.sort(function (a, b) {
            return a.toothNumber - b.toothNumber;
          });
        }
      } else {
        ChildTeethData = this.state.TeethEruptionData;
        refereChartdata = this.state.ChildTeethData.sort(function (a, b) {
          return a.toothNumber - b.toothNumber;
        });
      }
    } else {
      ChildTeethData = this.state.TeethEruptionData;
      refereChartdata = this.state.ChildTeethData.sort(function (a, b) {
        return a.toothNumber - b.toothNumber;
      });
    }
    console.log("show ref childlist-->", refereChartdata);
    return (
      <main className="main-container">
        <Helmet
          title="Baby Teething Chart, Age, Numbers, Order, Eruption & Shedding Details"
          meta={[
            {
              name: "description",
              content:
                "Keeping track of your baby’s teeth is indeed a tough task, FirstCry’s baby teething & shedding order chart will help you to know when do babies start teething and what age your child’s tooth erupt & shed.",
            },
            {
              name: "keywords",
              content:
                "Baby Teething,  Baby Teething Chart, Baby Teething Order",
            },
            { name: "atdlayout", content: "tools_sp" },
          ]}
        />
        <div className="title babyteething_title">
          <div className="breadcrumb R11_9e">
            <span>
              <a
                href={service.getRedirectUrl("/")}
                className="R11_9e">
                Home
              </a>
            </span>
            <span
              className="R11_9e breadcrum_icon"
              data-icon-font="l"></span>
            <span>
              <a
                href={service.getRedirectUrl("/tools")}
                className="R11_9e">
                Tools
              </a>
            </span>
            <span
              className="R11_9e breadcrum_icon"
              data-icon-font="l"></span>
            <span>Baby Teething</span>
          </div>
          {/* <h1 className="B24_00">Baby Teething {(this.state.isLogin && this.state.selectedChlname) ? <span>for {this.state.selectedChlname}</span> : null}</h1> */}
          <h1 className="B24_00" id="skipToH1" tabIndex={0}>Baby Teething Order & Chart</h1>
        </div>
        <div className="sub-container left baby-teething-tool">
          <div className="baby-teething-main data-container left">
            {this.state.showChildrenList ? (
              <div id="childDropdown">
                {userchildarray.length > 0 &&
                  userchildarray.map((childarray) =>
                    childarray.ChildId == this.state.selectedChlId ? (
                      <div
                        key={childarray.ChildId}
                        className="drop-down"
                        onClick={() => this.childrenlist()}>
                        <input
                          type="hidden"
                          id="selectedChildId"
                          name="selectedChildId"
                          value={childarray.ChildId}
                        />
                        <div className="selected-child">
                          <div className="M20_42">
                            <span className="childPic">
                              {childarray.childPhoto == "" ? (
                                <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png" alt="Default Profile Icon" title="Default Profile Icon" />
                              ) : (
                                <img src={childarray.childPhoto} />
                              )}
                            </span>
                            <input
                              type="hidden"
                              id="selectedChildDOB"
                              name="selectedChildDOB"
                              value={childarray.DOB}
                            />
                            <input
                              type="hidden"
                              id="selectedChildName"
                              name="selectedChildName"
                              value={childarray.ChildName}
                            />
                            <div className="diet-title">
                              {childarray.ChildName}
                            </div>

                            {(!userchildarray[0].IsExpected &&
                              userchildarray.length > 1) ||
                            (userchildarray[0].IsExpected &&
                              userchildarray.length > 2) ? (
                              this.state.isshowDropdown ? (
                                <span
                                  data-icon-font="n"
                                  className="M18_42 dropbtn right"></span>
                              ) : (
                                <span
                                  data-icon-font="f"
                                  className="M18_42 dropbtn right"></span>
                              )
                            ) : null}
                          </div>
                        </div>
                      </div>
                    ) : null
                  )}
                {userchildarray && userchildarray.length != 0 ? (
                  (global.userAry &&
                    global.userAry["childData"] &&
                    global.userAry["childData"]["UserChildList"] &&
                    userchildarray &&
                    userchildarray.length > 0 &&
                    userchildarray[0] &&
                    !userchildarray[0].IsExpected &&
                    userchildarray.length > 1) ||
                  (userchildarray &&
                    userchildarray[0].IsExpected &&
                    userchildarray.length > 2) ? (
                    <div className="dropdown">
                      <div
                        id="myDropdown"
                        className="dropdown-content"
                        style={{
                          display: this.state.isshowDropdown ? "block" : "none",
                        }}>
                        {userchildarray &&
                          userchildarray.map((childarray) =>
                            !childarray.IsExpected ? (
                              <div
                                key={childarray.ChildId}
                                className="children"
                                id={childarray.ChildId}
                                onClick={() =>
                                  this.selectChild(
                                    childarray.ChildId,
                                    childarray.ChildName,
                                    childarray.DOB
                                  )
                                }
                                style={{
                                  background:
                                    childarray.ChildId ==
                                    this.state.selectedChlId
                                      ? "#f5f5f5"
                                      : "#fff",
                                }}>
                                <span className="childPic">
                                  {childarray.childPhoto == "" ? (
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png" alt="Default Profile Icon" title="Default Profile Icon" />
                                  ) : (
                                    <img src={childarray.childPhoto} />
                                  )}
                                </span>
                                <span className="child_name R16_42">
                                  {childarray.ChildName}
                                </span>
                                {childarray.ChildId ==
                                this.state.selectedChlId ? (
                                  <span
                                    className="current_child right"
                                    data-icon-font=";"></span>
                                ) : null}
                              </div>
                            ) : null
                          )}
                      </div>
                    </div>
                  ) : null
                ) : null}
              </div>
            ) : null}
            <div className="jaw_section">
              <div className="baby-size-weeks">
                <div
                  className="weeks-section"
                  onScroll={() => teethactions.monthbarScroll(this)}>
                  <ul className="week-bar monthbar">
                    {this.displayMonthslider()}
                  </ul>
                </div>
                <span
                  className="week-next"
                  data-icon-font="h"
                  onClick={() => {
                    this.slideRight(this.state.clickwedWeek);
                  }}></span>
                <span
                  className="week-prev"
                  data-icon-font="g"
                  onClick={() => {
                    this.slideLeft(this.state.clickwedWeek);
                  }}></span>
              </div>
              <div className="tooth-erptn-inner">
                <span className="age-count baby-age M13_42">
                  Age:
                  <br />
                  <span id="baby-age">{this.state.isLogin ? this.currentM : 0} Months</span>
                </span>
                <span className="age-count baby-teeth-count M13_42">
                  Teeth:
                  <br />
                  <span className="teeth-count M13_42">
                    {this.state.teethCount ? this.state.teethCount : 0}
                  </span>
                </span>
                <div className="baby-jaw">
                  <img
                    src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/jaw-bg.svg"
                    alt="Jaw Image"
                    title="Jaw Image"
                  />
                  <span className="lower-jaw M16_white">Lower Jaw</span>
                  <span className="upper-jaw M16_e83f78">Upper Jaw</span>
                  {ChildTeethData.map((babyteeth) => (
                    <div
                      key={babyteeth.toothId}
                      className={
                        "baby-teeth teeth-" +
                        babyteeth.toothId +
                        babyteeth.toothNumber
                      }
                      id={babyteeth.toothId}>
                      {babyteeth.isHighLited == true ||
                      babyteeth.isHighLited == 1 ? (
                        // check erruption data
                        babyteeth.toothErruptionDate != "" &&
                        babyteeth.toothErruptionDate != null &&
                        !babyteeth.toothSheddingDate ? (
                          <div
                            className="white-teeth"
                            id={"white_" + babyteeth.toothId}
                            onClick={(e) =>
                              this.showDet(1, "white_" + babyteeth.toothId)
                            }>
                            <span className="teethnum M13_42">
                              {babyteeth.toothNumber}
                            </span>
                            {babyteeth.toothNumber == 9 ||
                            babyteeth.toothNumber == 10 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-1.svg" 
                              alt="Erupted-teeth -1"  
                              title="Erupted-teeth -1" />
                            ) : babyteeth.toothNumber == 6 ||
                              babyteeth.toothNumber == 5 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-2.svg"
                              alt="Erupted-teeth -2"  
                              title="Erupted-teeth -2" />
                            ) : babyteeth.toothNumber == 8 ||
                              babyteeth.toothNumber == 7 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-3.svg"
                              alt="Erupted-teeth -3" 
                              title="Erupted-teeth -3" />
                            ) : babyteeth.toothNumber == 4 ||
                              babyteeth.toothNumber == 3 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-4.svg"
                              alt="Erupted-teeth -4"
                              title="Erupted-teeth -4" />
                            ) : babyteeth.toothNumber == 1 ||
                              babyteeth.toothNumber == 2 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-5.svg"
                              alt="Erupted-teeth -5"
                              title="Erupted-teeth -5" />
                            ) : null}
                          </div>
                        ) : (
                          <div
                            className="gray-teeth"
                            id={"gray_" + babyteeth.toothId}
                            onClick={(e) =>
                              this.showDet(1, "gray_" + babyteeth.toothId)
                            }>
                            <span className="teethnum M13_42">
                              {babyteeth.toothNumber}
                            </span>
                            {babyteeth.toothNumber == 9 ||
                            babyteeth.toothNumber == 10 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/shed-teeth-1.svg"
                              alt="Shed Teeth"
                              title="Shed Teeth" />
                            ) : babyteeth.toothNumber == 6 ||
                              babyteeth.toothNumber == 5 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/shed-teeth-2.svg" />
                            ) : babyteeth.toothNumber == 8 ||
                              babyteeth.toothNumber == 7 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/shed-teeth-3.svg" />
                            ) : babyteeth.toothNumber == 4 ||
                              babyteeth.toothNumber == 3 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/shed-teeth-4.svg" />
                            ) : babyteeth.toothNumber == 1 ||
                              babyteeth.toothNumber == 2 ? (
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/shed-teeth-5.svg" />
                            ) : null}
                          </div>
                        )
                      ) : (
                        <div
                          className="pink-teeth"
                          id={"pink_" + babyteeth.toothId}
                          onClick={(e) =>
                            this.showDet(1, "pink_" + babyteeth.toothId)
                          }>
                          <span className="teethnum M13_white">
                            {babyteeth.toothNumber}
                          </span>
                          {babyteeth.toothNumber == 9 ||
                          babyteeth.toothNumber == 10 ? (
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink-teeth-1.svg"
                            alt="Pink Teeth -1"
                            title="Pink Teeth -1" />
                          ) : babyteeth.toothNumber == 6 ||
                            babyteeth.toothNumber == 5 ? (
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink-teeth-2.svg"
                            alt="Pink Teeth -2"
                            title="Pink Teeth -2" />
                          ) : babyteeth.toothNumber == 8 ||
                            babyteeth.toothNumber == 7 ? (
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink-teeth-3.svg"
                            alt="Pink Teeth -3" 
                            title="Pink Teeth -3"/>
                          ) : babyteeth.toothNumber == 4 ||
                            babyteeth.toothNumber == 3 ? (
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink-teeth-4.svg"
                            alt="Pink Teeth -4"
                            title="Pink Teeth -4" />
                          ) : babyteeth.toothNumber == 1 ||
                            babyteeth.toothNumber == 2 ? (
                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink-teeth-5.svg"
                            alt="Pink Teeth -5"
                            title="Pink Teeth -5" />
                          ) : null}
                        </div>
                      )}
                      <hr className={"myline info-line_" + babyteeth.toothId} />
                      <input
                        type="hidden"
                        value={
                          this.state.isLogin
                            ? babyteeth.startMonth
                            : babyteeth.startMonth
                        }
                        className="childstartmonth"
                      />
                      <input
                        type="hidden"
                        value={
                          this.state.isLogin
                            ? babyteeth.endMonth
                            : babyteeth.endMonth
                        }
                        className="childendmonth"
                      />
                      <input
                        type="hidden"
                        value={babyteeth.startYear}
                        className="childshedstartYear"
                      />
                      <input
                        type="hidden"
                        value={babyteeth.endYear}
                        className="childshedendYear"
                      />
                    </div>
                  ))}
                  <div className="tooth-info" data-month={this.state.toothMonth} data-tdetail={this.state.toothName} >
                    <div className="M14_e83f78">{this.state.toothName}</div>
                    <div className="R14_61">{this.state.toothMonth}</div>
                    {this.state.userDate && this.state.userDate != "" ? (
                      <div className="editdetails-cnt">
                        
                        <span className="M14_42">
                          {this.state.userDate}
                        </span>
                        <span
                          className="editdetails  curs_point icon"
                          data-icon-font="H"
                          onClick={() => {
                            this.addToothDetails(
                              this.state.currenttoothId,
                              this.state.selectedChlId,
                              this.state.userDate
                            );
                          }}></span>
                      </div>
                    ) : (
                      <div
                        className="askB_1 curs_point addDetail_click"
                        onClick={() => {
                          this.addToothDetails(
                            this.state.currenttoothId,
                            this.state.selectedChlId,
                            ""
                          );
                        }}>
                        
                        <span
                          className="addDetail icon"
                          data-icon-font="D">
                          
                        </span>
                        <span className="M13_white dev_add">Add Details </span>
                      </div>
                    )}
                  </div>
                </div>
                <span className="R M15_75 RnL">R</span>
                <span className="L M15_75 RnL">L</span>
              </div>
              <div className="teeth_types">
                <ul>
                  <li className="left">
                    <img
                      src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pink-teeth-1.svg"
                      alt="Pink Teeth -1"
                      title="Pink Teeth -1"
                    />
                    <span className="R14_42">Reference</span>
                  </li>
                  <li className="left">
                    <img
                      src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-1.svg"
                      alt="Erupted-teeth -1" 
                      title="Erupted-teeth -1"
                    />
                    <span className="R14_42">Erupted</span>
                  </li>
                  <li className="left">
                    <img
                      src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/shed-teeth-1.svg"
                      alt="Shed Teeth"
                      title="Shed Teeth" 
                    />
                    <span className="R14_42">Shed</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="teething-details">
              <div className="teeth_details_head">
                <div className="M18_21">Teething Details</div>
                <div className="R14_61 teeting-details-text">
                  The Chart shows when your child's primary teeth should erupt
                  and shed. Eruption/sheding time varies from child to child.
                </div>
              </div>
              <div className="teeth_references_container">
              <div className="teething_ref_strip GTM-teethReferences">
                  <span className="M15_42 GTM-teethReferences">
                    Teething References
                  </span>
                  {this.state.isToggleOn ? (
                    <span
                    className="right icon curs_point GTM-teethReferences"
                      data-icon-font="f"
                      onClick={() => this.toggleList()}></span>
                  ) : (
                    <span
                    className="right icon curs_point GTM-teethReferences"
                      data-icon-font="n"
                      onClick={() => this.toggleList()}></span>
                  )}
                </div>
                <ul
                  className={
                    this.state.isToggleOn
                      ? `reference_list hide`
                      : `reference_list show`
                  }>
                  {refereChartdata &&
                    refereChartdata.map((babyteeth) => (
                      <li key={babyteeth.toothId}>
                        {babyteeth.toothNumber == 1 ||
                        babyteeth.toothNumber == 2 ? (
                          <div>
                            <span className="left ref-tooth-img">
                              <img
                                className=""
                                src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-5.svg"
                                alt="Erupted-teeth -5"
                                title="Erupted-teeth -5"
                              />
                            </span>
                            <span className="left ref-data">
                              <ul>
                                <li className="M13_42">
                                  Tooth Number : {babyteeth.toothNumber}
                                </li>
                                <li className="R13_42">
                                  {babyteeth.toothNumber == 1
                                    ? "Lower "
                                    : "Upper "}
                                  {babyteeth.toothName}
                                </li>
                                <li className="M13_42">
                                  Erupt: {babyteeth.startMonth}-
                                  {babyteeth.endMonth} M
                                </li>
                                <li className="M13_42">
                                  Shed: {babyteeth.startYear}-
                                  {babyteeth.endYear} yrs
                                </li>
                              </ul>
                            </span>
                            <span
                              className="left ref-userData"
                              style={{
                                display:
                                  this.state.isLogin &&
                                  this.state.selectedChlname != ""
                                    ? "block"
                                    : "none",
                              }}>
                              <ul>
                                <li className="R13_42">
                                  {this.state.selectedChlname}'s Teeth
                                </li>
                                <li className="M13_42">
                                  Erupt:
                                  {babyteeth.toothErruptionDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothErruptionDate)
                                      )
                                    : "  -"}
                                </li>
                                <li className="M13_42">
                                  Shed:
                                  {babyteeth.toothSheddingDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothSheddingDate)
                                      )
                                    : "  -"}
                                </li>
                              </ul>
                            </span>
                          </div>
                        ) : babyteeth.toothNumber == 3 ||
                          babyteeth.toothNumber == 4 ? (
                          <div>
                            <span className="left ref-tooth-img">
                              <img
                                className=""
                                src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-4.svg"
                                alt="Erupted-teeth -4"
                                title="Erupted-teeth -4"
                              />
                            </span>
                            <span className="left ref-data">
                              <ul>
                                <li className="M13_42">
                                  Tooth Number : {babyteeth.toothNumber}
                                </li>
                                <li className="R13_42">
                                  {babyteeth.toothNumber == 4
                                    ? "Lower "
                                    : "Upper "}
                                  {babyteeth.toothName}
                                </li>
                                <li className="M13_42">
                                  Erupt: {babyteeth.startMonth}-
                                  {babyteeth.endMonth} M
                                </li>
                                <li className="M13_42">
                                  Shed: {babyteeth.startYear}-
                                  {babyteeth.endYear} yrs
                                </li>
                              </ul>
                            </span>
                            <span
                              className="left ref-userData"
                              style={{
                                display:
                                  this.state.isLogin &&
                                  this.state.selectedChlname != ""
                                    ? "block"
                                    : "none",
                              }}>
                              <ul>
                                <li className="R13_42">
                                  {this.state.selectedChlname}'s Teeth
                                </li>
                                <li className="M13_42">
                                  Erupt:
                                  {babyteeth.toothErruptionDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothErruptionDate)
                                      )
                                    : "  -"}
                                </li>
                                <li className="M13_42">
                                  Shed:
                                  {babyteeth.toothSheddingDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothSheddingDate)
                                      )
                                    : "  -"}
                                </li>
                              </ul>
                            </span>
                          </div>
                        ) : babyteeth.toothNumber == 5 ||
                          babyteeth.toothNumber == 6 ? (
                          <div>
                            <span className="left ref-tooth-img">
                              <img
                                className=""
                                src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-2.svg"
                                alt="Erupted-teeth -2"  
                                title="Erupted-teeth -2"
                              />
                            </span>
                            <span className="left ref-data">
                              <ul>
                                <li className="M13_42">
                                  Tooth Number : {babyteeth.toothNumber}
                                </li>
                                <li className="R13_42">
                                  {babyteeth.toothNumber == 6
                                    ? "Lower "
                                    : "Upper "}
                                  {babyteeth.toothName}
                                </li>
                                <li className="M13_42">
                                  Erupt: {babyteeth.startMonth}-
                                  {babyteeth.endMonth} M
                                </li>
                                <li className="M13_42">
                                  Shed: {babyteeth.startYear}-
                                  {babyteeth.endYear} yrs
                                </li>
                              </ul>
                            </span>
                            <span
                              className="left ref-userData"
                              style={{
                                display:
                                  this.state.isLogin &&
                                  this.state.selectedChlname != ""
                                    ? "block"
                                    : "none",
                              }}>
                              <ul>
                                <li className="R13_42">
                                  {this.state.selectedChlname}'s Teeth
                                </li>
                                <li className="M13_42">
                                  Erupt:
                                  {babyteeth.toothErruptionDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothErruptionDate)
                                      )
                                    : "  -"}
                                </li>
                                <li className="M13_42">
                                  Shed:
                                  {babyteeth.toothSheddingDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothSheddingDate)
                                      )
                                    : "  -"}
                                </li>
                              </ul>
                            </span>
                          </div>
                        ) : babyteeth.toothNumber == 7 ||
                          babyteeth.toothNumber == 8 ? (
                          <div>
                            <span className="left ref-tooth-img">
                              <img
                                className=""
                                src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-3.svg"
                                alt="Erupted-teeth -3" 
                                title="Erupted-teeth -3"
                              />
                            </span>
                            <span className="left ref-data">
                              <ul>
                                <li className="M13_42">
                                  Tooth Number : {babyteeth.toothNumber}
                                </li>
                                <li className="R13_42">
                                  {babyteeth.toothNumber == 8
                                    ? "Lower "
                                    : "Upper "}
                                  {babyteeth.toothName}
                                </li>
                                <li className="M13_42">
                                  Erupt: {babyteeth.startMonth}-
                                  {babyteeth.endMonth} M
                                </li>
                                <li className="M13_42">
                                  Shed: {babyteeth.startYear}-
                                  {babyteeth.endYear} yrs
                                </li>
                              </ul>
                            </span>
                            <span
                              className="left ref-userData"
                              style={{
                                display:
                                  this.state.isLogin &&
                                  this.state.selectedChlname != ""
                                    ? "block"
                                    : "none",
                              }}>
                              <ul>
                                <li className="R13_42">
                                  {this.state.selectedChlname}'s Teeth
                                </li>
                                <li className="M13_42">
                                  Erupt:
                                  {babyteeth.toothErruptionDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothErruptionDate)
                                      )
                                    : "  -"}
                                </li>
                                <li className="M13_42">
                                  Shed:
                                  {babyteeth.toothSheddingDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothSheddingDate)
                                      )
                                    : "  -"}
                                </li>
                              </ul>
                            </span>
                          </div>
                        ) : babyteeth.toothNumber == 9 ||
                          babyteeth.toothNumber == 10 ? (
                          <div>
                            <span className="left ref-tooth-img">
                              <img
                                className=""
                                src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Erupted-teeth-1.svg"
                                alt="Erupted-teeth -1"  
                                title="Erupted-teeth -1"
                              />
                            </span>
                            <span className="left ref-data">
                              <ul>
                                <li className="M13_42">
                                  Tooth Number : {babyteeth.toothNumber}
                                </li>
                                <li className="R13_42">
                                  {babyteeth.toothNumber == 9
                                    ? "Lower "
                                    : "Upper "}
                                  {babyteeth.toothName}
                                </li>
                                <li className="M13_42">
                                  Erupt: {babyteeth.startMonth}-
                                  {babyteeth.endMonth} M
                                </li>
                                <li className="M13_42">
                                  Shed: {babyteeth.startYear}-
                                  {babyteeth.endYear} yrs
                                </li>
                              </ul>
                            </span>
                            <span className="left ref-userData">
                              <ul
                                style={{
                                  display:
                                    this.state.isLogin &&
                                    this.state.selectedChlname != ""
                                      ? "block"
                                      : "none",
                                }}>
                                <li className="R13_42">
                                  {this.state.selectedChlname}'s Teeth
                                </li>
                                <li className="M13_42">
                                  Erupt:
                                  {babyteeth.toothErruptionDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothErruptionDate)
                                      )
                                    : "  -"}
                                </li>
                                <li className="M13_42">
                                  Shed:
                                  {babyteeth.toothSheddingDate
                                    ? this.getOnlydate(
                                        new Date(babyteeth.toothSheddingDate)
                                      )
                                    : "  -"}
                                </li>
                              </ul>
                            </span>
                          </div>
                        ) : null}
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            <div className="article_block">
              <div className="articles_heading">
                <h2 className="M18_42">Related Articles</h2>
              </div>
              <div
                className="article_slider_cont"
                id="article_slider_cont">
                <ul
                  className="article_slider left"
                  data-count={this.state.ArticlesData.length}>
                  {this.state.ArticlesData &&
                    this.state.ArticlesData.map((articles) => (
                      <li
                        key={articles.articleId}
                        className="article_slide left" data-id={articles.articleId} data-name={articles.articleTitle} >
                        <a
                          href={articles.articleUrl}
                          target="_blank">
                          <div className="article_info">
                            <div className="article_img">
                              {this.state.defaultArtImg ? (
                                <img
                                  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/defaultTeethArticle.jpg"
                                  className="dev_art_img"
                                />
                              ) : (
                                <img
                                  src={`${articles.articleImage}`.replace(
                                    /\.jpg$/i,
                                    ".webp"
                                  )}
                                  className="dev_art_img"
                                />
                              )}
                            </div>
                            <span className="R14_42 art_title">
                              {articles.articleTitle}
                            </span>
                          </div>
                        </a>
                      </li>
                    ))}
                </ul>
              </div>

              <span
                className="prev"
                onClick={() =>
                  service.slideSlider("article_slider_cont", -300, 1000)
                }>
                <span
                  data-icon-font="g"
                  className="icon"></span>
              </span>

              <span
                className="next"
                onClick={() =>
                  service.slideSlider("article_slider_cont", 300, 1000)
                }>
                <span
                  data-icon-font="h"
                  className="icon"></span>
              </span>
            </div>
          </div>
        </div>
        <div
          className="toast-msg"
          style={{ display: this.state.showmsg ? "block" : "none" }}>
          <div className="message">
            The chart shows when your child’s primary teeth should erupt and
            shed. Eruption/Shedding timeline varies from child to child
          </div>
        </div>
        <div className="test-internet-error">
          <div className="save-success">Please check internet connection</div>
        </div>
        <Right url={this.props.location.pathname} />
      </main>
    );
  }
}

export default withContext(BabyTeething);
